import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { APPLY_URL } from '../config';

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Header Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-[#FF5722] font-bold text-4xl md:text-5xl mb-2">Contact Us</h2>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">GET IN TOUCH</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ready to make The Summit on King your home? Contact us by phone. We look forward to meeting you.
          </p>
        </div>
      </div>

      {/* Contact Cards Section */}
      <div className="py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Left Column - Contact Card */}
            <div className="space-y-6">
              <Card className="border border-gray-200 hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-[#FF5722] p-3 rounded-lg shrink-0">
                      <Phone className="h-6 w-6 text-white" />
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-xl font-semibold mb-2">Phone</h3>
                      <p className="text-gray-600 mb-2">Call us directly to speak with our leasing team</p>
                      <a 
                        href="tel:8284141040" 
                        className="md:hidden text-[#FF5722] font-semibold hover:underline transition-colors"
                      >
                        828-414-1040
                      </a>
                      <span className="hidden md:inline text-[#FF5722] font-semibold">
                        828-414-1040
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <a
                href={APPLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-apply-button"
                className="inline-flex items-center justify-center w-full border-2 border-[#FF5722] bg-[#FF5722] text-white font-semibold px-6 py-3 rounded-md hover:bg-transparent hover:text-[#FF5722] transition-colors"
              >
                APPLY NOW
              </a>
            </div>

            {/* Right Column - Info Box and Video Tours */}
            <div className="md:col-span-2 space-y-8">
              {/* Info Box */}
              <div className="bg-gray-50 p-8 rounded-lg">
                <p className="text-gray-600 mb-6">
                  Experience The Summit on King for yourself! Our leasing team is ready to show you around our beautiful apartments and answer any questions you may have.
                </p>
                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-[#FF5722] rounded-full"></div>
                    <span className="text-gray-700">Studio, 1-, 2- & 3-bedroom apartments available</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-[#FF5722] rounded-full"></div>
                    <span className="text-gray-700">Directly across from Appalachian State University</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-[#FF5722] rounded-full"></div>
                    <span className="text-gray-700">On King Street in the heart of Downtown Boone</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-[#FF5722] rounded-full"></div>
                    <span className="text-gray-700">Walkable to shops, dining, and everyday essentials</span>
                  </div>
                </div>
              </div>

              {/* Video Tours Section */}
              <div className="bg-white p-8 border border-gray-200 rounded-lg">
                <h2 className="text-2xl font-bold mb-4">
                  Take a <span className="text-[#FF5722]">Video Tour</span>
                </h2>
                <p className="text-gray-600 mb-6">
                  Video tours coming soon! Explore photos and floor plans of each unit to choose the layout that's best for you.
                </p>
                <button
                  onClick={() => navigate('/gallery')}
                  className="inline-flex items-center text-[#FF5722] font-bold hover:underline transition-colors uppercase tracking-wide"
                >
                  VIEW GALLERY
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
